export default "__VITE_ASSET__Ihg7kety__"